import { observer } from "mobx-react-lite";
import { ConfigProvider, App as ContextApp } from "antd";
import zhCN from "antd/locale/zh_CN";
import { Layout } from "./components/Layout";
import { gstate } from "./gstate";
import { PopUpContext } from "./context";
import "dayjs/locale/zh-cn";
import dayjs from "dayjs";

dayjs.locale("zh-cn");

export const App = observer(({ children }) => {
  let content = null;
  if (gstate.pathname === "login") {
    content = children;
  } else {
    content = <Layout>{children}</Layout>;
  }
  return (
    <ConfigProvider
      locale={zhCN}
      theme={
        {
          // token: {
          //   colorPrimary: "#0d6efd",
          //   borderRadius: 0,
          // },
        }
      }
    >
      <ContextApp>
        <PopUpContext />
        {content}
      </ContextApp>
    </ConfigProvider>
  );
});
